import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { WithTooltip } from '@shared/ui';
import CircularProgress from '@mui/material/CircularProgress';
const FfpBonusInfoBlock = ({ className, bonusMiles, loading, error }) => {
    const { FfpBonusInfoBlock: css } = useTheme('Entities').FareGroupV2;
    const { t } = useTranslation('FareGroup');
    const renderIcon = () => {
        if (loading) {
            return React.createElement(CircularProgress, { size: 20, classes: { colorPrimary: css.loader } });
        }
        return React.createElement(CdnIcon, { className: css.icon, icon: "Services/Miles" });
    };
    const renderValue = () => {
        let value = bonusMiles;
        if (loading || error) {
            value = '—';
        }
        const tooltipTitle = error ? error : !loading ? t('FfpBonusInfo_Tooltip') : '';
        return (React.createElement(WithTooltip, { title: tooltipTitle, enterTouchDelay: 0 },
            React.createElement("span", { className: css.value }, value)));
    };
    return (React.createElement("div", { className: cn(css.root, className, { [css.loading]: loading }) },
        React.createElement("div", { className: css.leftBlock },
            renderIcon(),
            React.createElement("span", { className: css.title }, t('Miles to be credited'))),
        renderValue()));
};
export default FfpBonusInfoBlock;
